import dynamic from "next/dynamic";
const AgreementPage = dynamic(() => import("@/app/(pages)/_components/AgreementPage"));
const PageWrapper = dynamic(() => import("@/app/(pages)/_components/PageWrapper"));
const BlogListPage = dynamic(() => import("@/app/(pages)/blog/BlogList"));
const BlogLayout = dynamic(() => import("@/components/blog/BlogLayout"));
import RoutePaths from "./routePaths.js";
import HomePage from "@/app/(pages)/HomePage";
import PersonalCategory from "@/app/(pages)/personal";
import NamesGenerator from "@/app/(pages)/personal/names";
import FakeAddressGenerator from "@/app/(pages)/personal/fake-address";
import FakeEmailGenerator from "@/app/(pages)/personal/fake-email";
import IPAddressGenerator from "@/app/(pages)/personal/ip-address";
import PasswordGenerator from "@/app/(pages)/personal/password-generator";
import PrivacyPolicyPage from "@/app/(pages)/privacy-policy/en.mdx";
import PrivacyPolicyPageEs from "@/app/(pages)/privacy-policy/es.mdx";
import PrivacyPolicyPagePt from "@/app/(pages)/privacy-policy/pt.mdx";
import PrivacyPolicyPageHi from "@/app/(pages)/privacy-policy/hi.mdx";
import PrivacyPolicyPageAr from "@/app/(pages)/privacy-policy/ar.mdx";
import PrivacyPolicyPageFr from "@/app/(pages)/privacy-policy/fr.mdx";
import PrivacyPolicyPageDe from "@/app/(pages)/privacy-policy/de.mdx";
import PrivacyPolicyPageJa from "@/app/(pages)/privacy-policy/ja.mdx";
import PrivacyPolicyPageTr from "@/app/(pages)/privacy-policy/tr.mdx";
import PrivacyPolicyPageKo from "@/app/(pages)/privacy-policy/ko.mdx";
import PrivacyPolicyPageId from "@/app/(pages)/privacy-policy/id.mdx";
import PrivacyPolicyPageVi from "@/app/(pages)/privacy-policy/vi.mdx";
import PrivacyPolicyPageRu from "@/app/(pages)/privacy-policy/ru.mdx";
import PrivacyPolicyPageIt from "@/app/(pages)/privacy-policy/it.mdx";
import PrivacyPolicyPagePl from "@/app/(pages)/privacy-policy/pl.mdx";
import PrivacyPolicyPageNl from "@/app/(pages)/privacy-policy/nl.mdx";
import TermsOfUsePage from "@/app/(pages)/terms-of-use/en.mdx";
import TermsOfUsePageEs from "@/app/(pages)/terms-of-use/es.mdx";
import TermsOfUsePagePt from "@/app/(pages)/terms-of-use/pt.mdx";
import TermsOfUsePageHi from "@/app/(pages)/terms-of-use/hi.mdx";
import TermsOfUsePageAr from "@/app/(pages)/terms-of-use/ar.mdx";
import TermsOfUsePageFr from "@/app/(pages)/terms-of-use/fr.mdx";
import TermsOfUsePageDe from "@/app/(pages)/terms-of-use/de.mdx";
import TermsOfUsePageJa from "@/app/(pages)/terms-of-use/ja.mdx";
import TermsOfUsePageTr from "@/app/(pages)/terms-of-use/tr.mdx";
import TermsOfUsePageKo from "@/app/(pages)/terms-of-use/ko.mdx";
import TermsOfUsePageId from "@/app/(pages)/terms-of-use/id.mdx";
import TermsOfUsePageVi from "@/app/(pages)/terms-of-use/vi.mdx";
import TermsOfUsePageRu from "@/app/(pages)/terms-of-use/ru.mdx";
import TermsOfUsePageIt from "@/app/(pages)/terms-of-use/it.mdx";
import TermsOfUsePagePl from "@/app/(pages)/terms-of-use/pl.mdx";
import TermsOfUsePageNl from "@/app/(pages)/terms-of-use/nl.mdx";
import AboutPage from "@/app/(pages)/about/en.mdx";
import AboutPageEs from "@/app/(pages)/about/es.mdx";
import AboutPagePt from "@/app/(pages)/about/pt.mdx";
import AboutPageHi from "@/app/(pages)/about/hi.mdx";
import AboutPageAr from "@/app/(pages)/about/ar.mdx";
import AboutPageFr from "@/app/(pages)/about/fr.mdx";
import AboutPageDe from "@/app/(pages)/about/de.mdx";
import AboutPageJa from "@/app/(pages)/about/ja.mdx";
import AboutPageTr from "@/app/(pages)/about/tr.mdx";
import AboutPageKo from "@/app/(pages)/about/ko.mdx";
import AboutPageId from "@/app/(pages)/about/id.mdx";
import AboutPageVi from "@/app/(pages)/about/vi.mdx";
import AboutPageRu from "@/app/(pages)/about/ru.mdx";
import AboutPageIt from "@/app/(pages)/about/it.mdx";
import AboutPagePl from "@/app/(pages)/about/pl.mdx";
import AboutPageNl from "@/app/(pages)/about/nl.mdx";
import WhyYouNeedAFakeNamePage from "@/app/(contents)/why-you-need-a-fake-name/en.mdx";
import WhyYouNeedAFakeNamePageEs from "@/app/(contents)/why-you-need-a-fake-name/es.mdx";
import WhyYouNeedAFakeNamePagePt from "@/app/(contents)/why-you-need-a-fake-name/pt.mdx";
import WhyYouNeedAFakeNamePageHi from "@/app/(contents)/why-you-need-a-fake-name/hi.mdx";
import WhyYouNeedAFakeNamePageAr from "@/app/(contents)/why-you-need-a-fake-name/ar.mdx";
import WhyYouNeedAFakeNamePageFr from "@/app/(contents)/why-you-need-a-fake-name/fr.mdx";
import WhyYouNeedAFakeNamePageDe from "@/app/(contents)/why-you-need-a-fake-name/de.mdx";
import WhyYouNeedAFakeNamePageJa from "@/app/(contents)/why-you-need-a-fake-name/ja.mdx";
import WhyYouNeedAFakeNamePageTr from "@/app/(contents)/why-you-need-a-fake-name/tr.mdx";
import WhyYouNeedAFakeNamePageKo from "@/app/(contents)/why-you-need-a-fake-name/ko.mdx";
import WhyYouNeedAFakeNamePageId from "@/app/(contents)/why-you-need-a-fake-name/id.mdx";
import WhyYouNeedAFakeNamePageVi from "@/app/(contents)/why-you-need-a-fake-name/vi.mdx";
import WhyYouNeedAFakeNamePageRu from "@/app/(contents)/why-you-need-a-fake-name/ru.mdx";
import WhyYouNeedAFakeNamePageIt from "@/app/(contents)/why-you-need-a-fake-name/it.mdx";
import WhyYouNeedAFakeNamePagePl from "@/app/(contents)/why-you-need-a-fake-name/pl.mdx";
import WhyYouNeedAFakeNamePageNl from "@/app/(contents)/why-you-need-a-fake-name/nl.mdx";

import EntertainmentCategory from "@/app/(pages)/entertainment";
import GameNamesGenerator from "@/app/(pages)/entertainment/game-names";
import UnifiedFantasyDndNamesGenerator from "@/app/(pages)/entertainment/fantasy-dnd-names";
import MythologyNamesGenerator from "@/app/(pages)/entertainment/mythology-names";
import HorrorNamesGenerator from "@/app/(pages)/entertainment/horror-names";
import FunnyNamesGenerator from "@/app/(pages)/entertainment/funny-names";
import WildWestNamesGenerator from "@/app/(pages)/entertainment/wild-west-names";
const MedievalNamesGenerator = dynamic(() => import("@/app/(pages)/entertainment/medieval-names"));

/* ... imports ... */

export const Routes = {

    home: {
        ...RoutePaths.home,
        component: HomePage,
        wrapper: null,
        mdxComponent: null
    },
    about: {
        ...RoutePaths.about,
        component: null,
        wrapper: PageWrapper,
        mdxComponent: {
            en: AboutPage,
            es: AboutPageEs,
            pt: AboutPagePt,
            hi: AboutPageHi,
            ar: AboutPageAr,
            fr: AboutPageFr,
            de: AboutPageDe,
            ja: AboutPageJa,
            tr: AboutPageTr,
            ko: AboutPageKo,
            id: AboutPageId,
            vi: AboutPageVi,
            ru: AboutPageRu,
            it: AboutPageIt,
            pl: AboutPagePl,
            nl: AboutPageNl,
        }
    },
    privacyPolicy: {
        ...RoutePaths.privacyPolicy,
        component: null,
        wrapper: AgreementPage,
        mdxComponent: {
            en: PrivacyPolicyPage,
            es: PrivacyPolicyPageEs,
            pt: PrivacyPolicyPagePt,
            hi: PrivacyPolicyPageHi,
            ar: PrivacyPolicyPageAr,
            fr: PrivacyPolicyPageFr,
            de: PrivacyPolicyPageDe,
            ja: PrivacyPolicyPageJa,
            tr: PrivacyPolicyPageTr,
            ko: PrivacyPolicyPageKo,
            id: PrivacyPolicyPageId,
            vi: PrivacyPolicyPageVi,
            ru: PrivacyPolicyPageRu,
            it: PrivacyPolicyPageIt,
            pl: PrivacyPolicyPagePl,
            nl: PrivacyPolicyPageNl,
        }
    },
    termsOfUse: {
        ...RoutePaths.termsOfUse,
        component: null,
        wrapper: AgreementPage,
        mdxComponent: {
            en: TermsOfUsePage,
            es: TermsOfUsePageEs,
            pt: TermsOfUsePagePt,
            hi: TermsOfUsePageHi,
            ar: TermsOfUsePageAr,
            fr: TermsOfUsePageFr,
            de: TermsOfUsePageDe,
            ja: TermsOfUsePageJa,
            tr: TermsOfUsePageTr,
            ko: TermsOfUsePageKo,
            id: TermsOfUsePageId,
            vi: TermsOfUsePageVi,
            ru: TermsOfUsePageRu,
            it: TermsOfUsePageIt,
            pl: TermsOfUsePagePl,
            nl: TermsOfUsePageNl,
        }
    },
    personal: {
        ...RoutePaths.personal,
        component: PersonalCategory,
        wrapper: null,
        mdxComponent: null
    },
    names: {
        ...RoutePaths.names,
        component: NamesGenerator,
        wrapper: null,
        mdxComponent: null
    },
    addresses: {
        ...RoutePaths.addresses,
        component: FakeAddressGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'emails': {
        ...RoutePaths['emails'],
        component: FakeEmailGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'ip-addresses': {
        ...RoutePaths['ip-addresses'],
        component: IPAddressGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'password-generator': {
        ...RoutePaths['password-generator'],
        component: PasswordGenerator,
        wrapper: null,
        mdxComponent: null
    },
    blog: {
        ...RoutePaths.blog,
        component: BlogListPage,
        wrapper: null,
        mdxComponent: null
    },
    'why-you-need-a-fake-name': {
        ...RoutePaths['why-you-need-a-fake-name'],
        component: null,
        wrapper: BlogLayout,
        mdxComponent: {
            en: WhyYouNeedAFakeNamePage,
            es: WhyYouNeedAFakeNamePageEs,
            pt: WhyYouNeedAFakeNamePagePt,
            hi: WhyYouNeedAFakeNamePageHi,
            ar: WhyYouNeedAFakeNamePageAr,
            fr: WhyYouNeedAFakeNamePageFr,
            de: WhyYouNeedAFakeNamePageDe,
            ja: WhyYouNeedAFakeNamePageJa,
            tr: WhyYouNeedAFakeNamePageTr,
            ko: WhyYouNeedAFakeNamePageKo,
            id: WhyYouNeedAFakeNamePageId,
            vi: WhyYouNeedAFakeNamePageVi,
            ru: WhyYouNeedAFakeNamePageRu,
            it: WhyYouNeedAFakeNamePageIt,
            pl: WhyYouNeedAFakeNamePagePl,
            nl: WhyYouNeedAFakeNamePageNl,
        }
    },
    entertainment: {
        ...RoutePaths.entertainment,
        component: EntertainmentCategory,
        wrapper: null,
        mdxComponent: null
    },
    'game-names': {
        ...RoutePaths['game-names'],
        component: GameNamesGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'fantasy-dnd-names': {
        ...RoutePaths['fantasy-dnd-names'],
        component: UnifiedFantasyDndNamesGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'mythology-names': {
        ...RoutePaths['mythology-names'],
        component: MythologyNamesGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'horror-names': {
        ...RoutePaths['horror-names'],
        component: HorrorNamesGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'funny-names': {
        ...RoutePaths['funny-names'],
        component: FunnyNamesGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'medieval-names': {
        ...RoutePaths['medieval-names'],
        component: MedievalNamesGenerator,
        wrapper: null,
        mdxComponent: null
    },
    'wild-west-names': {
        ...RoutePaths['wild-west-names'],
        component: WildWestNamesGenerator,
        wrapper: null,
        mdxComponent: null
    },
    // 'pet-names': {
    //     ...RoutePaths['pet-names'],
    //     component: PetNamesGenerator,
    // },
    // 'fantasy-character-names': {
    //     ...RoutePaths['fantasy-character-names'],
    //     component: FantasyCharacterNamesGenerator,
    // },
    // 'movie-character-names': {
    //     ...RoutePaths['movie-character-names'],
    //     component: MovieCharacterNamesGenerator,
    // },
    // nicknames: {
    //     ...RoutePaths.nicknames,
    //     component: NicknamesGenerator,
    // },
    // 'superhero-names': {
    //     ...RoutePaths['superhero-names'],
    //     component: SuperheroNamesGenerator,
    // }
}